export { default } from './OrderPayment'



// WEBPACK FOOTER //
// ./src/App/pages/OrderPayment/index.js